import { Card, Divider, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useBarChart } from '../hooks/useBarChart';
import { Loader } from './Loader';
import { AppBarChart } from './charts/BarChart';

const SubConcernCategoryBarChart = ({ subConcernData }) => {
  const { graphData, loading, setGraphData, setLoading, setYAxis, yAxis } =
    useBarChart();

  useEffect(() => {
    if (subConcernData) {
      setGraphData(subConcernData);

      const values = subConcernData.map((item) => Number(item.value));
      setYAxis({ min: Math.min(...values), max: Math.max(...values) });

      setLoading(false);
    }
  }, [subConcernData]);

  return (
    <Card
      variant="outlined"
      sx={{
        boxShadow: 3,
        width: '100%',
        height: '350px',
        p: '25px',
        background: '#1d2637',
        color: 'white',
        borderRadius: '12px',
        fontFamily: 'Montserrat, serif !important',
      }}
    >
      <Typography
        sx={{ fontFamily: 'Montserrat, serif !important' }}
        variant="overline"
        gutterBottom
      >
        Sub Concern Category
      </Typography>
      <Divider />
      {loading ? (
        <Loader />
      ) : subConcernData.length === 0 ? (
        <Typography
          variant="body2"
          sx={{
            textAlign: 'center',
            color: 'white',
            mt: 2,
            fontFamily: 'Montserrat, serif !important',
          }}
        >
          No concerns recorded.
        </Typography>
      ) : (
        <AppBarChart
          data={graphData}
          xAxisKey={'reason'}
          xLabel={'Sub Concern'}
          yLabel={'Count'}
          dataKey={'value'}
          yMax={yAxis.max}
          yMin={yAxis.min}
          fill="#FB9C0C"
          yMaxOffset={0}
          yMinOffset={0}
        />
      )}
    </Card>
  );
};

export default SubConcernCategoryBarChart;
